import {useState} from 'react'
import {useHelper, useHttpClient} from '../../../../modules/services/Bundle'
import {RequestMethod} from '../../../../modules/services/core/_enums'
import {FileModel} from '../../../../modules/services/core/_models'

type Props = {
  endpoint: string
  method: RequestMethod
  disabled: boolean
  data?: any
  queryObject?: any
}

const BotaoBaixarResultadoExcel = ({endpoint, method, disabled, data, queryObject}: Props) => {
  const [baixando, setBaixando] = useState(false)
  const httpClient = useHttpClient()
  const helper = useHelper()

  const baixar = async () => {
    setBaixando(true)

    try {
      const response = await httpClient.request({
        method,
        endpoint,
        data,
        queryObject,
      })

      if (response.success && response.payload) {
        const file: FileModel = response.payload
        await helper.downloadFile(file)
      }
    } finally {
      setBaixando(false)
    }
  }

  return (
    <button
      type='button'
      className='btn btn-sm btn-primary d-flex align-items-center'
      disabled={disabled || baixando}
      onClick={baixar}
    >
      {baixando ? (
        <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
      ) : (
        <i className='fa-solid fa-file-excel me-2'></i>
      )}
      {baixando ? 'Gerando Excel...' : 'Baixar Excel'}
    </button>
  )
}

export {BotaoBaixarResultadoExcel}
